/* unplugin-vue-components disabled */import { render } from "./PriceCalculateLoad.vue?vue&type=template&id=527c0ec0&scoped=true"
import script from "./PriceCalculateLoad.vue?vue&type=script&lang=js"
export * from "./PriceCalculateLoad.vue?vue&type=script&lang=js"

import "./PriceCalculateLoad.vue?vue&type=style&index=0&id=527c0ec0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527c0ec0"]])

export default __exports__